import React, { useState, useEffect } from 'react';
import { API_URL, fmtFecha, descargarBase64, SUCURSAL_NOMBRES } from '../constants';

// ════════════════════════════════════════════════════════════════════════════
// MODAL CONFIRMAR IMSS — muestra altas + bajas antes de generar y marcar
// ════════════════════════════════════════════════════════════════════════════
export function ModalConfirmarIMSS({ bajasSeleccionadas, onClose, onDone }) {
  const [altas, setAltas] = useState([]);
  const [loadingAltas, setLoadingAltas] = useState(true);
  const [selAltas, setSelAltas] = useState({});
  const [selBajas, setSelBajas] = useState(() => {
    const init = {};
    bajasSeleccionadas.forEach(b => { init[b.id] = true; });
    return init;
  });
  const [generando, setGenerando] = useState(false);

  useEffect(() => {
    fetch(API_URL + '?path=api/pendientes/altas-bajas')
      .then(r => r.json())
      .then(d => {
        if (d.success) {
          const a = d.altas || [];
          setAltas(a);
          const init = {};
          a.forEach(x => { init[x.id] = true; });
          setSelAltas(init);
        }
      })
      .catch(() => {})
      .finally(() => setLoadingAltas(false));
  }, []);

  const altasConf = altas.filter(a => selAltas[a.id]);
  const bajasConf = bajasSeleccionadas.filter(b => selBajas[b.id]);

  const handleGenerar = async () => {
    if (!altasConf.length && !bajasConf.length) { alert('Selecciona al menos un empleado.'); return; }
    setGenerando(true);
    try {
      const payload = { idsBajas: bajasConf.map(b => b.id), idsAltas: altasConf.map(a => a.id) };
      const url = API_URL + `?path=api/bajas/generar-hoja-imss&payload=${encodeURIComponent(JSON.stringify(payload))}`;
      const res = await fetch(url);
      const data = await res.json();
      if (data.success) {
        descargarBase64(data.base64, data.filename);
        alert(`✅ Hoja IMSS generada — ${data.total_bajas} baja(s) y ${data.total_altas} alta(s) marcadas como enviadas.`);
        onDone();
      } else {
        alert('❌ Error: ' + data.error);
      }
    } catch (err) {
      alert('Error: ' + err.message);
    } finally {
      setGenerando(false);
    }
  };

  const thS = { padding: '8px 10px', textAlign: 'left', fontSize: '12px', fontWeight: 600, color: '#4b5563' };
  const tdS = { padding: '8px 10px', fontSize: '13px', borderBottom: '1px solid #f3f4f6' };

  return (
    <div className="modal-overlay">
      <div className="modal" style={{ maxWidth: '640px' }}>
        <div className="modal-header">
          <h2>Confirmar Hoja IMSS</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body" style={{ maxHeight: '65vh', overflowY: 'auto' }}>
          <p style={{ fontSize: '13px', color: '#6b7280', marginBottom: '16px' }}>
            Selecciona los empleados que se incluirán en el archivo y quedarán marcados como <strong>enviados al contador</strong>.
          </p>

          {/* BAJAS */}
          <div style={{ marginBottom: '20px' }}>
            <div style={{ fontWeight: 700, fontSize: '13px', color: '#991b1b', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <i className="ti ti-user-minus"></i> Bajas seleccionadas ({bajasConf.length}/{bajasSeleccionadas.length})
            </div>
            <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
              <thead style={{ background: '#fef2f2' }}>
                <tr><th style={thS}></th><th style={thS}># Emp</th><th style={thS}>Nombre</th><th style={thS}>Fecha Baja</th></tr>
              </thead>
              <tbody>
                {bajasSeleccionadas.map(b => (
                  <tr key={b.id} style={{ background: selBajas[b.id] ? '#fff5f5' : 'white' }}>
                    <td style={{ ...tdS, width: '36px' }}><input type="checkbox" checked={!!selBajas[b.id]} onChange={() => setSelBajas(p => ({ ...p, [b.id]: !p[b.id] }))} /></td>
                    <td style={{ ...tdS, fontFamily: 'monospace', color: '#6b7280' }}>#{b.id}</td>
                    <td style={{ ...tdS, fontWeight: 500 }}>{b.nombre}</td>
                    <td style={{ ...tdS, color: '#6b7280' }}>{fmtFecha(b.fecha_baja_a)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* ALTAS */}
          <div>
            <div style={{ fontWeight: 700, fontSize: '13px', color: '#166534', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <i className="ti ti-user-plus"></i> Altas pendientes detectadas ({loadingAltas ? '...' : `${altasConf.length}/${altas.length}`})
            </div>
            {loadingAltas ? (
              <div style={{ padding: '16px', textAlign: 'center', color: '#9ca3af', fontSize: '13px' }}>Buscando altas pendientes...</div>
            ) : altas.length === 0 ? (
              <div style={{ padding: '16px', background: '#f9fafb', borderRadius: '8px', color: '#9ca3af', fontSize: '13px', textAlign: 'center' }}>Sin altas pendientes de enviar al contador</div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
                <thead style={{ background: '#f0fdf4' }}>
                  <tr><th style={thS}></th><th style={thS}># Emp</th><th style={thS}>Nombre</th><th style={thS}>Fecha Ingreso</th></tr>
                </thead>
                <tbody>
                  {altas.map(a => (
                    <tr key={a.id} style={{ background: selAltas[a.id] ? '#f0fdf4' : 'white' }}>
                      <td style={{ ...tdS, width: '36px' }}><input type="checkbox" checked={!!selAltas[a.id]} onChange={() => setSelAltas(p => ({ ...p, [a.id]: !p[a.id] }))} /></td>
                      <td style={{ ...tdS, fontFamily: 'monospace', color: '#6b7280' }}>#{a.id}</td>
                      <td style={{ ...tdS, fontWeight: 500 }}>{a.nombre}</td>
                      <td style={{ ...tdS, color: '#6b7280' }}>{a.fecha_ingreso || '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose} disabled={generando}>Cancelar</button>
          <button className="btn-primary" onClick={handleGenerar} disabled={generando || (!altasConf.length && !bajasConf.length)}>
            {generando ? 'Generando...' : `Generar y Marcar Enviados (${bajasConf.length + altasConf.length})`}
          </button>
        </div>
      </div>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════════════════
// VISTA BAJAS — 3 tabs: Baja A / Baja B / Baja C Historial
// ════════════════════════════════════════════════════════════════════════════
export function VistaBajas({ onVerExpediente }) {
  const [tab, setTab] = useState('a');
  const [bajas, setBajas] = useState({ bajas_a: [], bajas_b: [], bajas_c: [] });
  const [loading, setLoading] = useState(true);
  const [seleccionados, setSeleccionados] = useState({});
  const [procesando, setProcesando] = useState(false);
  const [finiquitoEmpleado, setFiniquitoEmpleado] = useState(null);
  const [finiquitoMultiple, setFiniquitoMultiple] = useState(null);
  const [modalIMSS, setModalIMSS] = useState(null); // array de baja objects para confirmar
  const [modalDarDeBaja, setModalDarDeBaja] = useState(null); // Task 2.6: modal para dar de baja con reclutamiento

  const abrirModalIMSS = (ids) => {
    const listaBajas = bajas.bajas_b.filter(b => ids.includes(b.id));
    setModalIMSS(listaBajas);
  };
  const [busqueda, setBusqueda] = useState('');

  const cargar = async () => {
    setLoading(true);
    try {
      const res = await fetch(API_URL + '?path=api/bajas/listar');
      const data = await res.json();
      if (data.success) setBajas(data);
    } catch {}
    finally { setLoading(false); }
  };

  React.useEffect(() => { cargar(); }, []);

  const toggleSel = (id) => setSeleccionados(prev => ({ ...prev, [id]: !prev[id] }));
  const toggleTodos = (lista) => {
    const ids = lista.map(b => b.id);
    const todosSeleccionados = ids.every(id => seleccionados[id]);
    const nuevo = { ...seleccionados };
    ids.forEach(id => { nuevo[id] = !todosSeleccionados; });
    setSeleccionados(nuevo);
  };

  const procesarBaja = async (tipoBaja) => {
    const ids = Object.keys(seleccionados).filter(id => seleccionados[id]);
    if (!ids.length) { alert('Selecciona al menos un empleado.'); return; }
    const label = tipoBaja === 'Baja_B_Sistema' ? 'Baja B — Sistema' : 'Baja C — IMSS';
    if (!window.confirm(`¿Procesar ${ids.length} empleado(s) a ${label}?`)) return;
    setProcesando(true);
    let errores = 0;
    for (const id of ids) {
      try {
        const url = API_URL + `?path=api/empleado/baja&payload=${encodeURIComponent(JSON.stringify({ id_empleado: id, tipo_baja: tipoBaja }))}`;
        const res = await fetch(url);
        const data = await res.json();
        if (!data.success) errores++;
      } catch { errores++; }
    }
    setProcesando(false);
    setSeleccionados({});
    if (errores > 0) alert(`⚠️ ${errores} error(s) al procesar.`);
    else alert(`✅ ${ids.length} empleado(s) procesados correctamente.`);
    await cargar();
  };

  const listaActual = tab === 'a' ? bajas.bajas_a : tab === 'b' ? bajas.bajas_b : bajas.bajas_c;
  const filtrada = listaActual.filter(b =>
    !busqueda || b.nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
    String(b.id).includes(busqueda)
  );

  const thStyle = { padding: '10px 12px', textAlign: 'left', fontWeight: 600, fontSize: '12px', color: '#4b5563', borderBottom: '2px solid #e5e7eb', whiteSpace: 'nowrap' };
  const tdStyle = { padding: '10px 12px', fontSize: '13px', color: '#1f2937', borderBottom: '1px solid #f3f4f6' };

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <div>
          <h1 style={{ fontSize: '22px', fontWeight: 700, color: '#1d3d6b', display: 'flex', alignItems: 'center', gap: '8px' }}><i className="ti ti-user-minus"></i> Bajas de Personal</h1>
          <p style={{ color: '#6b7280', fontSize: '13px', marginTop: '2px' }}>Control de proceso de baja por etapas</p>
        </div>
        <button className="btn-secondary" onClick={cargar} disabled={loading} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <i className="ti ti-refresh"></i> {loading ? 'Cargando...' : 'Recargar'}
        </button>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: '4px', marginBottom: '20px', borderBottom: '2px solid #e5e7eb' }}>
        {[
          { key: 'a', label: 'Baja A — Operativa', count: bajas.bajas_a.length, color: '#f59e0b' },
          { key: 'b', label: 'Baja B — Sistema', count: bajas.bajas_b.length, color: '#ef4444' },
          { key: 'c', label: 'Baja C / Historial', count: bajas.bajas_c.length, color: '#6b7280' },
        ].map(t => (
          <button key={t.key} onClick={() => { setTab(t.key); setSeleccionados({}); setBusqueda(''); }}
            style={{ padding: '10px 18px', border: 'none', background: 'none', cursor: 'pointer', fontWeight: tab === t.key ? 700 : 400,
              color: tab === t.key ? '#1d3d6b' : '#6b7280', borderBottom: tab === t.key ? '2px solid #1d3d6b' : '2px solid transparent',
              marginBottom: '-2px', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            {t.label}
            <span style={{ background: t.color, color: 'white', borderRadius: '10px', padding: '1px 8px', fontSize: '11px', fontWeight: 700 }}>{t.count}</span>
          </button>
        ))}
      </div>

      {/* Buscador */}
      <div style={{ marginBottom: '16px', display: 'flex', gap: '12px', alignItems: 'center' }}>
        <input
          type="text" placeholder="Buscar por nombre o ID..." value={busqueda}
          onChange={e => setBusqueda(e.target.value)}
          style={{ flex: 1, maxWidth: '320px', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '13px' }}
        />
        {tab === 'a' && (
          <>
            <button className="btn-primary" disabled={!Object.values(seleccionados).some(Boolean)}
              onClick={() => {
                const selLista = bajas.bajas_a.filter(b => seleccionados[b.id]);
                if (selLista.length === 1) setFiniquitoEmpleado(selLista[0]);
                else setFiniquitoMultiple(selLista);
              }}
              style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <i className="ti ti-file-spreadsheet"></i>
              {(() => { const n = Object.values(seleccionados).filter(Boolean).length; return n <= 1 ? 'Solicitar Finiquito' : `Solicitar Finiquito (${n})`; })()}
            </button>
            <button className="btn-secondary" onClick={() => procesarBaja('Baja_B_Sistema')} disabled={procesando || !Object.values(seleccionados).some(Boolean)}
              style={{ display: 'flex', alignItems: 'center', gap: '6px' }} title="Usar después de recibir el finiquito">
              <i className="ti ti-arrow-right"></i> {procesando ? 'Procesando...' : 'Finiquito Recibido → Baja B'}
            </button>
          </>
        )}
        {tab === 'b' && (
          <>
            <button className="btn-primary" disabled={!Object.values(seleccionados).some(Boolean)}
              onClick={() => {
                const ids = Object.keys(seleccionados).filter(id => seleccionados[id]);
                abrirModalIMSS(ids);
              }}
              style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <i className="ti ti-building-hospital"></i>
              {(() => { const n = Object.values(seleccionados).filter(Boolean).length; return n <= 1 ? 'Generar Hoja IMSS' : `Generar Hoja IMSS (${n})`; })()}
            </button>
            <button className="btn-secondary" onClick={() => procesarBaja('Baja_C_IMSS')} disabled={procesando || !Object.values(seleccionados).some(Boolean)}
              style={{ display: 'flex', alignItems: 'center', gap: '6px' }} title="Usar cuando la baja IMSS ya está confirmada">
              <i className="ti ti-arrow-right"></i> {procesando ? 'Procesando...' : 'IMSS Confirmado → Baja C'}
            </button>
          </>
        )}
      </div>

      {/* Tabla */}
      {loading ? (
        <div style={{ textAlign: 'center', padding: '60px', color: '#9ca3af' }}>
          <i className="ti ti-loader" style={{ fontSize: '32px', display: 'block', marginBottom: '10px' }}></i>
          Cargando bajas...
        </div>
      ) : filtrada.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px', color: '#9ca3af', background: 'white', borderRadius: '12px' }}>
          <i className="ti ti-user-off" style={{ fontSize: '36px', display: 'block', marginBottom: '10px' }}></i>
          {busqueda ? 'Sin resultados para la búsqueda.' : 'No hay empleados en esta etapa.'}
        </div>
      ) : (
        <div style={{ background: 'white', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ background: '#f9fafb' }}>
              <tr>
                {(tab === 'a' || tab === 'b') && (
                  <th style={{ ...thStyle, width: '36px' }}>
                    <input type="checkbox" onChange={() => toggleTodos(filtrada)}
                      checked={filtrada.length > 0 && filtrada.every(b => seleccionados[b.id])} />
                  </th>
                )}
                <th style={thStyle}># Emp</th>
                <th style={thStyle}>Nombre</th>
                <th style={thStyle}>Sucursal</th>
                <th style={thStyle}>Puesto</th>
                <th style={thStyle}>F. Ingreso</th>
                {tab !== 'a' && <th style={thStyle}>F. Baja A</th>}
                {tab === 'c' && <th style={thStyle}>F. Baja B</th>}
                <th style={thStyle}>Motivo</th>
                <th style={thStyle}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {filtrada.map(b => (
                <tr key={b.id} style={{ background: seleccionados[b.id] ? '#f0f9ff' : 'white' }}>
                  {(tab === 'a' || tab === 'b') && (
                    <td style={{ ...tdStyle, textAlign: 'center' }}>
                      <input type="checkbox" checked={!!seleccionados[b.id]} onChange={() => toggleSel(b.id)} />
                    </td>
                  )}
                  <td style={{ ...tdStyle, fontFamily: 'monospace', color: '#6b7280', fontSize: '12px' }}>#{b.id}</td>
                  <td style={{ ...tdStyle, fontWeight: 600 }}>{b.nombre}</td>
                  <td style={tdStyle}>{SUCURSAL_NOMBRES[b.sucursal] || b.sucursal}</td>
                  <td style={tdStyle}>{b.puesto}</td>
                  <td style={tdStyle}>{fmtFecha(b.fecha_ingreso)}</td>
                  {tab !== 'a' && <td style={tdStyle}>{fmtFecha(b.fecha_baja_a)}</td>}
                  {tab === 'c' && <td style={tdStyle}>{fmtFecha(b.fecha_baja_b)}</td>}
                  <td style={tdStyle}>
                    <span style={{ background: '#fef3c7', color: '#92400e', padding: '2px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: 600 }}>
                      {b.motivo_baja || '—'}
                    </span>
                  </td>
                  <td style={{ ...tdStyle, whiteSpace: 'nowrap' }}>
                    <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                      {onVerExpediente && (
                        <button onClick={() => onVerExpediente({ id: b.id, nombre: b.nombre, sucursal: b.sucursal, area: '', puesto: b.puesto, estatus: tab === 'a' ? 'Baja_A_Operativa' : tab === 'b' ? 'Baja_B_Sistema' : 'Baja_C_IMSS' })}
                          style={{ padding: '4px 10px', border: '1px solid #d1d5db', borderRadius: '6px', background: 'white', cursor: 'pointer', fontSize: '12px', color: '#374151' }}>
                          <i className="ti ti-folder"></i> Expediente
                        </button>
                      )}
                      {/* Tab A: Task 2.6 - Dar de Baja button */}
                      {tab === 'a' && (
                        <button onClick={() => setModalDarDeBaja(b)}
                          style={{ padding: '4px 10px', border: '1px solid #991b1b', borderRadius: '6px', background: '#dc2626', cursor: 'pointer', fontSize: '12px', color: 'white' }}>
                          <i className="ti ti-user-minus"></i> Dar de Baja
                        </button>
                      )}
                      {/* Tab A: botón individual de finiquito */}
                      {tab === 'a' && (
                        b.url_finiquito
                          ? <a href={b.url_finiquito} target="_blank" rel="noreferrer"
                              style={{ padding: '4px 10px', border: '1px solid #059669', borderRadius: '6px', background: '#059669', fontSize: '12px', color: 'white', textDecoration: 'none' }}>
                              <i className="ti ti-check"></i> Ver Finiquito
                            </a>
                          : <button onClick={() => setFiniquitoEmpleado(b)}
                              style={{ padding: '4px 10px', border: '1px solid #1d3d6b', borderRadius: '6px', background: '#1d3d6b', cursor: 'pointer', fontSize: '12px', color: 'white' }}>
                              <i className="ti ti-file-spreadsheet"></i> Finiquito
                            </button>
                      )}
                      {/* Tab B: botón individual hoja IMSS */}
                      {tab === 'b' && (
                        <button onClick={() => abrirModalIMSS([b.id])}
                          style={{ padding: '4px 10px', border: '1px solid #7c3aed', borderRadius: '6px', background: '#7c3aed', cursor: 'pointer', fontSize: '12px', color: 'white' }}>
                          <i className="ti ti-building-hospital"></i> Hoja IMSS
                        </button>
                      )}
                      {/* Tab C: finiquito y hoja IMSS */}
                      {tab === 'c' && b.url_finiquito && (
                        <a href={b.url_finiquito} target="_blank" rel="noreferrer"
                          style={{ padding: '4px 10px', border: '1px solid #059669', borderRadius: '6px', background: '#059669', fontSize: '12px', color: 'white', textDecoration: 'none' }}>
                          <i className="ti ti-download"></i> Finiquito
                        </a>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {finiquitoEmpleado && (
        <ModalFiniquito
          baja={finiquitoEmpleado}
          onClose={() => setFiniquitoEmpleado(null)}
          onDone={() => { setFiniquitoEmpleado(null); setSeleccionados({}); cargar(); }}
        />
      )}

      {finiquitoMultiple && (
        <ModalFiniquitoMultiple
          bajas={finiquitoMultiple}
          onClose={() => setFiniquitoMultiple(null)}
          onDone={() => { setFiniquitoMultiple(null); setSeleccionados({}); cargar(); }}
        />
      )}

      {modalIMSS && (
        <ModalConfirmarIMSS
          bajasSeleccionadas={modalIMSS}
          onClose={() => setModalIMSS(null)}
          onDone={() => { setModalIMSS(null); setSeleccionados({}); cargar(); }}
        />
      )}

      {/* Task 2.6: Modal Dar de Baja with Reclutamiento Integration */}
      {modalDarDeBaja && (
        <ModalDarDeBaja
          baja={modalDarDeBaja}
          onClose={() => setModalDarDeBaja(null)}
          onDone={() => { setModalDarDeBaja(null); setSeleccionados({}); cargar(); }}
        />
      )}
    </div>
  );
}

// ════════════════════════════════════════════════════════════════════════════
// MODAL DAR DE BAJA — with Reclutamiento integration (Task 2.6)
// ════════════════════════════════════════════════════════════════════════════
export function ModalDarDeBaja({ baja, onClose, onDone }) {
  const [fechaSalida, setFechaSalida] = useState(new Date().toISOString().split('T')[0]);
  const [motivoBaja, setMotivoBaja] = useState('');
  const [garantiaInfo, setGarantiaInfo] = useState(null);
  const [bonoInfo, setBonoInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [procesando, setProcesando] = useState(false);

  React.useEffect(() => {
    const cargarInfo = async () => {
      setLoading(true);
      try {
        // Fetch guarantee info
        const garantiaRes = await fetch(API_URL + `?path=api/reclutamiento/garantia-empleado&id_empleado=${baja.id}`);
        const garantiaData = await garantiaRes.json();
        if (garantiaData.success && garantiaData.data) {
          setGarantiaInfo(garantiaData.data);
        }

        // Fetch bonus info
        const bonoRes = await fetch(API_URL + `?path=api/reclutamiento/bono-empleado&id_empleado=${baja.id}`);
        const bonoData = await bonoRes.json();
        if (bonoData.success && bonoData.data) {
          setBonoInfo(bonoData.data);
        }
      } catch (err) {
        console.error('Error fetching reclutamiento info:', err);
      } finally {
        setLoading(false);
      }
    };

    cargarInfo();
  }, [baja.id]);

  const handleConfirmarBaja = async () => {
    if (!fechaSalida || !motivoBaja.trim()) {
      alert('Por favor completa Fecha de Salida y Motivo de Baja');
      return;
    }

    setProcesando(true);
    try {
      const payload = {
        id_empleado: baja.id,
        fecha_baja: fechaSalida,
        motivo_baja: motivoBaja,
        tipo_baja: 'Baja_A_Operativa'
      };
      const url = API_URL + `?path=api/empleado/baja&payload=${encodeURIComponent(JSON.stringify(payload))}`;
      const res = await fetch(url);
      const data = await res.json();

      if (data.success) {
        // Show success message with details about guarantee/bonus
        let mensaje = `✅ Empleado ${baja.nombre} marcado como Baja\n\n`;

        if (data.garantia && data.garantia.existe) {
          mensaje += `⚠️ Garantía de agencia: Se creó reposición automática\n`;
          mensaje += `   Agencia: ${data.garantia.agencia}\n`;
          mensaje += `   Reposición ID: ${data.garantia.id_garantia_reposicion}\n`;
          mensaje += `   Período de reposición: ${data.garantia.dias_reposicion} días\n\n`;
        }

        if (data.bono && data.bono.existe) {
          mensaje += `ℹ️ Bono de referencia: Segundo pago cancelado\n`;
          mensaje += `   Bono ID: ${data.bono.id_bono}\n`;
          mensaje += `   Recomendante: ${data.bono.nombre_recomendante}\n`;
          mensaje += `   Monto cancelado: $${data.bono.monto_segundo_pago}\n`;
        }

        if (!data.garantia && !data.bono) {
          mensaje += '(Sin información de reclutamiento)';
        }

        alert(mensaje);
        onDone();
      } else {
        alert('❌ Error: ' + data.error);
      }
    } catch (err) {
      alert('Error: ' + err.message);
    } finally {
      setProcesando(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={() => !procesando && onClose()}>
      <div className="modal" style={{ maxWidth: '600px' }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2><i className="ti ti-user-minus"></i> Dar de Baja: {baja.nombre}</h2>
          <button className="modal-close" onClick={onClose} disabled={procesando}>✕</button>
        </div>
        <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          {/* Información del empleado */}
          <div style={{ background: '#f8fafc', borderRadius: '8px', padding: '14px', marginBottom: '20px' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', fontSize: '13px' }}>
              <div>
                <span style={{ color: '#6b7280' }}>ID Empleado:</span>
                <div style={{ fontWeight: 600 }}>#{baja.id}</div>
              </div>
              <div>
                <span style={{ color: '#6b7280' }}>Sucursal:</span>
                <div style={{ fontWeight: 500 }}>{baja.sucursal}</div>
              </div>
              <div style={{ gridColumn: '1 / -1' }}>
                <span style={{ color: '#6b7280' }}>Puesto:</span>
                <div style={{ fontWeight: 500 }}>{baja.puesto}</div>
              </div>
            </div>
          </div>

          {/* Sección 1: Información de Baja */}
          <div style={{ marginBottom: '20px' }}>
            <div style={{ fontWeight: 700, fontSize: '13px', color: '#1f2937', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <i className="ti ti-calendar"></i> Información de Baja
            </div>
            <div className="form-group" style={{ marginBottom: '12px' }}>
              <label>Fecha de Salida *</label>
              <input type="date" value={fechaSalida} onChange={e => setFechaSalida(e.target.value)} />
            </div>
            <div className="form-group">
              <label>Motivo de Baja *</label>
              <input type="text" placeholder="Ej. Renuncia, Despido, etc." value={motivoBaja}
                onChange={e => setMotivoBaja(e.target.value)} />
            </div>
          </div>

          {/* Sección 2: Verificación de Reclutamiento */}
          <div style={{ background: '#f0f9ff', borderRadius: '8px', padding: '14px', border: '1px solid #bfdbfe', marginBottom: '20px' }}>
            <div style={{ fontWeight: 700, fontSize: '13px', color: '#1e40af', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <i className="ti ti-alert-circle"></i> Verificación de Reclutamiento
            </div>

            {loading ? (
              <div style={{ color: '#9ca3af', fontSize: '13px' }}>Buscando información de garantías y bonos...</div>
            ) : !garantiaInfo && !bonoInfo ? (
              <div style={{ color: '#6b7280', fontSize: '13px' }}>
                <i className="ti ti-check"></i> Sin información de reclutamiento pendiente
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {garantiaInfo && (
                  <div style={{ background: 'white', borderRadius: '6px', padding: '10px', borderLeft: '3px solid #f59e0b' }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                      <input type="checkbox" checked={true} disabled style={{ marginTop: '3px' }} />
                      <div style={{ flex: 1, fontSize: '12px' }}>
                        <div style={{ fontWeight: 600, color: '#1f2937', marginBottom: '4px' }}>
                          ⚠️ Garantía de agencia pendiente
                        </div>
                        <div style={{ color: '#6b7280' }}>
                          <div>Agencia: <strong>{garantiaInfo.agencia}</strong></div>
                          <div>Vencimiento: <strong>{fmtFecha(garantiaInfo.fecha_vencimiento)}</strong></div>
                          <div>Días restantes: <strong>{garantiaInfo.dias_restantes} días</strong></div>
                          <div style={{ marginTop: '6px', padding: '6px', background: '#fef3c7', borderRadius: '4px', color: '#92400e' }}>
                            ℹ️ Se creará reposición automática (GAR-REP-...)
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {bonoInfo && (
                  <div style={{ background: 'white', borderRadius: '6px', padding: '10px', borderLeft: '3px solid #3b82f6' }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                      <input type="checkbox" checked={true} disabled style={{ marginTop: '3px' }} />
                      <div style={{ flex: 1, fontSize: '12px' }}>
                        <div style={{ fontWeight: 600, color: '#1f2937', marginBottom: '4px' }}>
                          ℹ️ Bono de referencia pendiente
                        </div>
                        <div style={{ color: '#6b7280' }}>
                          <div>Recomendante: <strong>{bonoInfo.nombre_recomendante}</strong></div>
                          <div>Días desde ingreso: <strong>{bonoInfo.dias_desde_ingreso} días</strong></div>
                          <div>Monto segundo pago: <strong>${bonoInfo.monto_segundo_pago}</strong></div>
                          <div style={{ marginTop: '6px', padding: '6px', background: '#dbeafe', borderRadius: '4px', color: '#1e40af' }}>
                            {bonoInfo.puede_cancelar
                              ? '✓ Se cancelará el segundo pago automáticamente'
                              : '✗ Período de 90 días ya cumplido (pago fue procesado)'}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose} disabled={procesando}>Cancelar</button>
          <button className="btn-primary" onClick={handleConfirmarBaja} disabled={procesando || !fechaSalida || !motivoBaja.trim()}>
            {procesando ? 'Procesando...' : 'Confirmar Baja'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════════════════
// MODAL FINIQUITO MÚLTIPLE — genera un Excel con varios empleados
// ════════════════════════════════════════════════════════════════════════════
export function ModalFiniquitoMultiple({ bajas, onClose, onDone }) {
  const [filas, setFilas] = React.useState(() =>
    bajas.map(b => ({ id: b.id, nombre: b.nombre, dias_pendientes: '', dias_vacaciones: '', loading_vac: true }))
  );
  const [generando, setGenerando] = React.useState(false);

  React.useEffect(() => {
    bajas.forEach((b, i) => {
      fetch(API_URL + `?path=api/empleado/calcular-vacaciones&id=${b.id}`)
        .then(r => r.json())
        .then(data => {
          if (data.success) {
            setFilas(prev => prev.map((f, idx) => idx === i
              ? { ...f, dias_vacaciones: String(data.dias_vacaciones), loading_vac: false }
              : f));
          } else {
            setFilas(prev => prev.map((f, idx) => idx === i ? { ...f, loading_vac: false } : f));
          }
        })
        .catch(() => setFilas(prev => prev.map((f, idx) => idx === i ? { ...f, loading_vac: false } : f)));
    });
  }, []);

  const setFila = (i, campo, valor) =>
    setFilas(prev => prev.map((f, idx) => idx === i ? { ...f, [campo]: valor } : f));

  const handleGenerar = async () => {
    const sinPendientes = filas.find(f => f.dias_pendientes === '');
    if (sinPendientes) { alert(`Falta ingresar Días Pendientes para ${sinPendientes.nombre}.`); return; }
    setGenerando(true);
    try {
      const payload = {
        empleados: filas.map((f, i) => ({
          id_empleado: bajas[i].id,
          dias_pendientes: f.dias_pendientes,
          dias_vacaciones: f.dias_vacaciones
        }))
      };
      const url = API_URL + `?path=api/bajas/generar-finiquito-multiple&payload=${encodeURIComponent(JSON.stringify(payload))}`;
      const res = await fetch(url);
      const data = await res.json();
      if (data.success) {
        descargarBase64(data.base64, data.filename);
        onDone();
      } else {
        alert('❌ Error: ' + data.error);
      }
    } catch (err) {
      alert('Error: ' + err.message);
    } finally {
      setGenerando(false);
    }
  };

  const thS = { padding: '8px 10px', textAlign: 'left', fontWeight: 600, fontSize: '12px', color: '#4b5563', background: '#f3f4f6', borderBottom: '1px solid #e5e7eb' };
  const tdS = { padding: '8px 10px', fontSize: '13px', borderBottom: '1px solid #f3f4f6', verticalAlign: 'middle' };

  return (
    <div className="modal-overlay" onClick={() => !generando && onClose()}>
      <div className="modal" style={{ maxWidth: '680px' }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Generar Solicitud de Finiquito — {bajas.length} empleados</h2>
          <button className="modal-close" onClick={onClose} disabled={generando}>✕</button>
        </div>
        <div className="modal-body" style={{ padding: '0' }}>
          <p style={{ padding: '14px 20px 8px', fontSize: '12px', color: '#6b7280', borderBottom: '1px solid #f3f4f6' }}>
            Completa los <strong>Días Pendientes</strong> para cada empleado. Los días de vacaciones se calcularon automáticamente (editables).
          </p>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th style={thS}># Emp</th>
                  <th style={thS}>Nombre</th>
                  <th style={thS}>Motivo</th>
                  <th style={{ ...thS, width: '120px' }}>Días Pendientes *</th>
                  <th style={{ ...thS, width: '120px' }}>Días Vacaciones</th>
                </tr>
              </thead>
              <tbody>
                {filas.map((f, i) => (
                  <tr key={f.id}>
                    <td style={{ ...tdS, fontFamily: 'monospace', color: '#6b7280', fontSize: '12px' }}>#{f.id}</td>
                    <td style={{ ...tdS, fontWeight: 500 }}>{f.nombre}</td>
                    <td style={tdS}>
                      <span style={{ background: '#fef3c7', color: '#92400e', padding: '2px 7px', borderRadius: '10px', fontSize: '11px' }}>
                        {bajas[i].motivo_baja || '—'}
                      </span>
                    </td>
                    <td style={tdS}>
                      <input type="number" min="0" step="0.5" value={f.dias_pendientes}
                        onChange={e => setFila(i, 'dias_pendientes', e.target.value)}
                        placeholder="0"
                        style={{ width: '90px', padding: '6px 8px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '13px' }} />
                    </td>
                    <td style={tdS}>
                      {f.loading_vac
                        ? <span style={{ color: '#9ca3af', fontSize: '12px' }}>calc...</span>
                        : <input type="number" min="0" step="0.5" value={f.dias_vacaciones}
                            onChange={e => setFila(i, 'dias_vacaciones', e.target.value)}
                            style={{ width: '90px', padding: '6px 8px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '13px' }} />
                      }
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose} disabled={generando}>Cancelar</button>
          <button className="btn-primary" onClick={handleGenerar} disabled={generando}>
            {generando ? 'Generando...' : <><i className="ti ti-file-spreadsheet"></i> Generar Excel ({bajas.length} empleados)</>}
          </button>
        </div>
      </div>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════════════════
// MODAL FINIQUITO — pre-llena datos, RH completa días pendientes/vacaciones
// ════════════════════════════════════════════════════════════════════════════
export function ModalFiniquito({ baja, onClose, onDone }) {
  const [diasPendientes, setDiasPendientes] = useState('');
  const [diasVacaciones, setDiasVacaciones] = useState('');
  const [vacInfo, setVacInfo] = useState(null);
  const [generando, setGenerando] = useState(false);
  const [loadingVac, setLoadingVac] = useState(true);

  React.useEffect(() => {
    setLoadingVac(true);
    fetch(API_URL + `?path=api/empleado/calcular-vacaciones&id=${baja.id}`)
      .then(r => r.json())
      .then(data => {
        if (data.success) {
          setVacInfo(data);
          setDiasVacaciones(String(data.dias_vacaciones));
        }
      })
      .catch(() => {})
      .finally(() => setLoadingVac(false));
  }, [baja.id]);

  const anosServicio = (() => {
    if (!baja.fecha_ingreso || !baja.fecha_baja_a) return null;
    const ing = new Date(baja.fecha_ingreso + 'T12:00:00');
    const baj = new Date(baja.fecha_baja_a + 'T12:00:00');
    return ((baj - ing) / (365.25 * 24 * 60 * 60 * 1000)).toFixed(1);
  })();

  const handleGenerar = async () => {
    if (diasPendientes === '') { alert('Ingresa los Días Pendientes antes de generar.'); return; }
    setGenerando(true);
    try {
      const payload = {
        id_empleado: baja.id,
        motivo_baja: baja.motivo_baja,
        dias_pendientes: diasPendientes,
        dias_vacaciones: diasVacaciones
      };
      const url = API_URL + `?path=api/bajas/generar-finiquito&payload=${encodeURIComponent(JSON.stringify(payload))}`;
      const res = await fetch(url);
      const data = await res.json();
      if (data.success) {
        descargarBase64(data.base64, data.filename);
        onDone();
      } else {
        alert('❌ Error: ' + data.error);
      }
    } catch (err) {
      alert('Error: ' + err.message);
    } finally {
      setGenerando(false);
    }
  };

  const infoRow = (label, valor) => (
    <div style={{ display: 'flex', gap: '12px', padding: '6px 0', borderBottom: '1px solid #f3f4f6' }}>
      <span style={{ color: '#6b7280', fontSize: '12px', width: '140px', flexShrink: 0 }}>{label}</span>
      <span style={{ fontWeight: 500, fontSize: '13px', color: '#1f2937' }}>{valor || '—'}</span>
    </div>
  );

  return (
    <div className="modal-overlay" onClick={() => !generando && onClose()}>
      <div className="modal" style={{ maxWidth: '480px' }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Generar Solicitud de Finiquito</h2>
          <button className="modal-close" onClick={onClose} disabled={generando}>✕</button>
        </div>
        <div className="modal-body">
          <div style={{ background: '#f8fafc', borderRadius: '8px', padding: '14px', marginBottom: '20px' }}>
            {infoRow('Empleado', baja.nombre)}
            {infoRow('# Empleado', baja.id)}
            {infoRow('Sucursal', baja.sucursal)}
            {infoRow('Puesto', baja.puesto)}
            {infoRow('Fecha Ingreso', fmtFecha(baja.fecha_ingreso))}
            {infoRow('Fecha Baja A', fmtFecha(baja.fecha_baja_a))}
            {anosServicio && infoRow('Años de Servicio', anosServicio + ' años')}
            {infoRow('Motivo de Baja', baja.motivo_baja)}
            {baja.comentarios && infoRow('Comentarios', baja.comentarios)}
          </div>

          <div style={{ borderTop: '2px dashed #e5e7eb', paddingTop: '16px' }}>
            <p style={{ fontSize: '12px', color: '#6b7280', marginBottom: '14px', fontStyle: 'italic' }}>
              Completa los siguientes campos antes de generar el Excel:
            </p>
            <div className="form-group" style={{ marginBottom: '14px' }}>
              <label>Días Pendientes <span style={{ color: '#ef4444' }}>*</span></label>
              <input type="number" min="0" step="0.5" value={diasPendientes}
                onChange={e => setDiasPendientes(e.target.value)}
                placeholder="Ej. 3.5" />
            </div>
            <div className="form-group">
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                Días de Vacaciones
                {loadingVac && <span style={{ fontSize: '11px', color: '#9ca3af' }}>calculando...</span>}
                {vacInfo && !loadingVac && (
                  <span style={{ fontSize: '11px', color: '#059669', background: '#d1fae5', padding: '2px 8px', borderRadius: '10px' }}>
                    Auto: {vacInfo.dias_vacaciones} días ({vacInfo.ano_servicio_actual}° año → {vacInfo.dias_correspondientes} días/año)
                  </span>
                )}
              </label>
              <input type="number" min="0" step="0.5" value={diasVacaciones}
                onChange={e => setDiasVacaciones(e.target.value)}
                placeholder="Calculado automáticamente, editable" />
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose} disabled={generando}>Cancelar</button>
          <button className="btn-primary" onClick={handleGenerar} disabled={generando || diasPendientes === ''}>
            {generando ? 'Generando...' : <><i className="ti ti-file-spreadsheet"></i> Generar Excel</>}
          </button>
        </div>
      </div>
    </div>
  );
}
